import { render, staticRenderFns } from "./SwitchFieldCard.vue?vue&type=template&id=1829450d&"
import script from "./SwitchFieldCard.vue?vue&type=script&lang=js&"
export * from "./SwitchFieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports